import Axios from 'axios';
import { toast } from 'react-toastify';

const API_URL = process.env.REACT_APP_API_URL;

// IST timestamp for filenames
const istTimestamp = () => {
    const t = new Date(Date.now() + 5.5 * 3600000);
    return t.toISOString().replace(/[-T:.Z]/g, '').slice(0, 14);
};

// ── Download any Excel report ─────────────────────────────────
// filters = { labId, schoolId, mentorId, state, dateFrom, dateTo, parameter }
export const downloadReport = async (reportType, filters = {}) => {
    if (!reportType) {
        toast.error('Please select a report!', { position: 'top-center' });
        return;
    }

    // Build query string from all non-empty filter values
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
        if (v !== '' && v !== null && v !== undefined) {
            params.append(k, v);
        }
    });

    const qs  = params.toString() ? `?${params.toString()}` : '';
    const url = `${API_URL}/reports/${reportType}${qs}`;

    try {
        const response = await Axios.get(url, {
            responseType: 'blob',
            headers: { Authorization: localStorage.getItem('token') },
        });

        const filename = `${reportType}_${istTimestamp()}.xlsx`;
        const blobUrl  = window.URL.createObjectURL(new Blob([response.data]));
        const a        = document.createElement('a');
        a.href         = blobUrl;
        a.setAttribute('download', filename);
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);

        toast.success('Report downloaded!', { position: 'top-center' });
    } catch (error) {
        console.error('Download error:', error);
        toast.error('Failed to download the report.', { position: 'top-center' });
    }
};

// ── Fetch dashboard stats (JSON) ──────────────────────────────
// Returns { totals, byLab, byMentor, bySchool, byMonth } or null
export const fetchReportStats = async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
        if (v !== '' && v !== null && v !== undefined) {
            params.append(k, v);
        }
    });

    const qs = params.toString() ? `?${params.toString()}` : '';

    try {
        const response = await Axios.get(`${API_URL}/reports/dashboard_stats${qs}`, {
            headers: { Authorization: localStorage.getItem('token') },
        });
        if (response.data.status === 'success') {
            return response.data.data;
        }
        return null;
    } catch (error) {
        console.warn('Stats endpoint not available:', error.message);
        return null;
    }
};

// ADD this new function at the bottom of reportsFunction.js
// Do NOT touch downloadReport() or fetchReportStats()

// ── Download PDF report ───────────────────────────────────────
export const downloadPdfReport = async (reportType, filters = {}) => {
    if (!reportType) {
        toast.error('Please select a report!', { position: 'top-center' });
        return;
    }

    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
        if (v !== '' && v !== null && v !== undefined) {
            params.append(k, v);
        }
    });

    const qs  = params.toString() ? `?${params.toString()}` : '';
    const url = `${API_URL}/reports/pdf/${reportType}${qs}`;

    try {
        const response = await Axios.get(url, {
            responseType: 'blob',
            headers: { Authorization: localStorage.getItem('token') },
        });

        const ts       = new Date(Date.now() + 5.5*3600000).toISOString().replace(/[-T:.Z]/g,'').slice(0,14);
        const filename = `${reportType}_${ts}.pdf`;
        const blobUrl  = window.URL.createObjectURL(new Blob([response.data], { type:'application/pdf' }));
        const a        = document.createElement('a');
        a.href         = blobUrl;
        a.setAttribute('download', filename);
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);

        toast.success('PDF downloaded!', { position: 'top-center' });
    } catch (error) {
        console.error('PDF Download error:', error);
        toast.error('Failed to download PDF report.', { position: 'top-center' });
    }
};
